import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import OrganizationService from '@forwardflow/services/OrganizationService'
import { useOrgSWR } from '@forwardflow/hooks'

export const useGetDefaultConfigurations = () => {
   const response = useOrgSWR(
      [QUERY_KEYS.DEFAULT_CONFIG],
      () => OrganizationService.getDefaultConfigurations(),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate(),
   }
}
